












import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { FilterState } from '@/stores/modules/filter';

const filter = namespace('filter');

@Component({
  components: {}
})
export default class LocalizationFilter extends Vue {
  private selected: boolean = false;

  @filter.State('filter') filter: any;
  @filter.Mutation('setFilterItem') setFilterItem!: (item: {
    key: keyof FilterState['filter'];
    val: any;
  }) => void;
  mounted() {
    this.selected = this.valueSet;
  }

  get valueSet(): boolean {
    return this.filter['localizing'] && this.filter['comparing'];
  }

  @Watch('selected')
  onSelect(selected: boolean) {
    // @ts-ignore
    this.setFilterItem({ key: 'localizing', val: selected });
    this.setFilterItem({ key: 'comparing', val: selected });
  }
}
